import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	root: {
		background: theme.palette.background.dark,
		padding: theme.spacing(5, 0),
		position: "relative",
		[theme.breakpoints.up("md")]: {
			padding: theme.spacing(10, 0)
		},
		"& > .mco-view-component-container": {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(5),
			[theme.breakpoints.up("md")]: {
				display: "grid",
				gridTemplateColumns: "1fr 300px"
			},
			[theme.breakpoints.up("lg")]: {
				display: "grid",
				gridTemplateColumns: "1fr 416px"
			}
		}
	},
	headline: {
		color: "#FFFFFF",
		marginBottom: theme.spacing(3),
		paddingBottom: 20,
		position: "relative",
		"&:before": {
			background: theme.palette.secondary.dark,
			bottom: 0,
			content: "''",
			height: 4,
			left: 0,
			position: "absolute",
			width: 80
		}
	},
	title: {
		color: "#FFFFFF",
		marginBottom: theme.spacing(1)
	},
	text: {
		color: "#FFFFFF",
		marginBottom: theme.spacing(2.5)
	},
	wrapper: {
		display: "grid",
		gap: theme.spacing(2),
		gridTemplateColumns: "1fr",
		marginBottom: theme.spacing(4),
		[theme.breakpoints.up("sm")]: {
			gridTemplateColumns: "1fr 1fr 1fr"
		},
		[theme.breakpoints.up("md")]: {
			gap: theme.spacing(3)
		}
	},
	timeLabel: {
		borderBottom: "1px solid #CCCCCC",
		color: "#FFFFFF",
		marginBottom: theme.spacing(1),
		paddingBottom: 8
	},
	timeWrapper: {
		alignItems: "center",
		columnGap: theme.spacing(2),
		display: "grid",
		gridTemplateColumns: "72px 1fr"
	},
	icon: {
		"& path": {
			fill: "#FFFFFF !important"
		}
	},
	temp: {
		color: "#FFFFFF"
	},
	button: {
		color: "#FFFFFF !important",
		borderColor: "#FFFFFF !important",
		"& svg path": {
			fill: "#FFFFFF !important"
		},
		"&:hover": {
			background: "rgba(255,255,255,0.04) !important"
		}
	},
	headlineWebcam: {
		color: "#FFFFFF",
		marginBottom: theme.spacing(7),
		paddingBottom: 20,
		position: "relative",
		"&:before": {
			background: theme.palette.secondary.dark,
			bottom: 0,
			content: "''",
			height: 4,
			left: 0,
			position: "absolute",
			width: 80
		}
	},
	webcamWrapper: {
		display: "flex",
		height: "100%",
		position: "relative",
		width: "100%"
	},
	webcam: {
		"& iframe": {
			aspectRatio: "416 / 255"
		}
	},
	webcamTitle: {
		alignItems: "center",
		background: theme.palette.secondary.dark,
		color: "#FFFFFF",
		display: "flex",
		justifyContent: "center",
		left: 0,
		padding: theme.spacing(1, 2),
		position: "absolute",
		top: -14
	}
}));

export default styles;
